import * as types from './types';

export const applyFilter = (filter) => ({
  type: types.APPLY_FILTER,
  filter,
});

export const updateProfiles = (profiles) => ({
  type: types.UPDATE_PROFILES,
  profiles,
});

export const changeActiveDashboardId = (dashboardId) => ({
  type: types.CHANGE_ACTIVE_DASHBOARD_ID,
  dashboardId,
});

export const addNewDashboard = (newDashboard) => ({
  type: types.ADD_NEW_DASHBOARD,
  newDashboard,
});

export const updateInterval = (from, to, shortcut, dashboardType) => ({
  type: types.INTERVAL_SELECTION,
  from,
  to,
  shortcut,
  dashboardType,
});

export const updateGranularity = (granularity) => ({
  type: types.UPDATE_GRANULARITY,
  granularity,
});

export const toggleModal = (modalType) => ({
  type: types.TOGGLE_MODAL,
  modalType,
});

export const setDimensionsTypeOnFilters = (data) => ({
  type: types.SET_DIMENSION_TYPE_IN_FILTER,
  data,
});

export const updateFeatures = (features) => ({
  type: types.UPDATE_FEATURES,
  features,
});

export const updateAppAllMetrics = (appAllMetrics) => ({
  type: types.UPDATE_APP_ALL_METRICS,
  appAllMetrics,
});

export const updateUserDefinedMetrics = (userDefinedMetrics) => ({
  type: types.UPDATE_USER_DEFINED_METRICS,
  userDefinedMetrics,
});

export const setSharingState = (sharingState) => ({
  type: types.SET_SHARING_STATE,
  sharingState,
});

export const resetDiagnostics = () => ({
  type: types.RESET_DIAGNOSTICS,
});

export const setAppBackendType = (module) => ({
  type: types.SET_APP_BACKEND_TYPE,
  module,
});

export const changeIsSharingPage = (isSharingPage = false) => ({
  type: types.CHANGE_IS_SHARING_PAGE,
  isSharingPage,
});

export const persistState = (configuration) => ({
  type: types.PERSIST_STATE,
  configuration,
});

export const closeAllTabs = () => ({
  type: types.CLOSE_ALL_TABS,
});

export const refreshTrends = () => ({
  type: types.REFRESH_TRENDS,
});

export const toggleAnnotations = (value) => ({
  type: types.TOGGLE_ANNOTATIONS,
  value,
});

export const setRealTimeMode = (flag) => ({
  type: types.SET_REAL_TIME_MODE,
  flag,
});

export const setAiAlertsMapping = (mapData) => ({
  type: types.AI_ALERTS_DIMENSION_MAPPING,
  mapData,
});
